// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { string } from 'prop-types'
import {
  Input,
  Label,
} from './styles'

const Radio = ({ label, ...props }) => (
  <>
    <Input
      {...props}
      type={'radio'} />
    <Label
      htmlFor={props.id}
      id={`${props.id}-label`}>
      {label}
    </Label>
  </>
)

Radio.propTypes = {
  id: string.isRequired,
}

export default Radio
